import React from 'react';

import SimpleButton from '../components/atoms/SimpleButton';
import Headline from '../components/atoms/Headline';

import { Redirect } from 'react-router';



class NotFoundView extends React.Component {

    constructor(props) {
      super(props);
      this.goHome = this.goHome.bind(this);
      this.state = {
        home: false
      };
    }
    goHome() {
        this.setState({
        home: true
      });
    }

    render () {
        return (
            <div className="content">
            {
                this.state.home===true?
                <Redirect to="/" />
                :
                <div>
                    <Headline typeOf="h2" alignment="center" style={{margin:'30px 0 20px'}}>Der von Ihnen geforderte Inhalt wurde nicht gefunden.</Headline>
                    <div style={{textAlign:'center'}}>
                      <SimpleButton onClick={this.goHome}>Zur Startseite</SimpleButton>
                    </div>
                </div>
            }
            </div>
        );
    }

}

export default NotFoundView


// WEBPACK FOOTER //
// ./src/views/NotFoundView.js